export const getLondonDateKey = (date = new Date()) => (
  new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/London' }).format(date)
);

export default getLondonDateKey;
